import { styled } from '../jss-style';
import carouselStyle from './carousel';

const useCarouselStyle = styled(carouselStyle, 'carousel');
export { carouselStyle, useCarouselStyle };
export default useCarouselStyle;
